//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Dialog } from 'vant'
import { getColorByType } from 'counselor-mobile-ui/utils/ui/color'
import CatCompleteApproveOpinion from './cat-complete-approve-opinion'
import TextOverFlow from './cat-text-overflow.vue'
import {
  REPORT_STATUS_COMPLETE,
  REPORT_STATUS_FLOW_CONFIG,
  REPORT_STATUS_PASS,
  REPORT_STATUS_REJECT,
} from '@/public/config/reportStatus'

export default {

  name: 'CatCompleteFlowModal',

  components: {
    'v-dialog': Dialog.Component,
    CatCompleteApproveOpinion,
    TextOverFlow,
  },

  inheritAttrs: false,

  data () {
    return {
      REPORT_STATUS_FLOW_CONFIG,
      showStatus: false,
      logs: [],
    }
  },

  methods: {

    show ({ logs, reportApplyFlow }) {
      this.showStatus = true

      if (reportApplyFlow) {
        this.logs = logs.map((e, i) => {
          return {
            ...e,
            status: i !== logs.length - 1 && e.status === '3' ? '9' : e.status,
          }
        })
      } else {
        this.logs = logs
      }
    },

    // getUserHtml (item) {
    //   const { userName, status } = item

    //   if (!status) {
    //     return `${userName} - 发起申请`
    //   } else {
    //     const { fontClassname, label } = REPORT_STATUS_FLOW_CONFIG[status]
    //     const statusLabel = status === '9' ? `<span>审批<span class="${fontClassname}">${label}</span></span>` : `<span class="${fontClassname}">${label}</span>`

    //     return `${userName} -&nbsp;${statusLabel}`
    //   }
    // },

    showOpinion (item) {
      const { status } = item

      return REPORT_STATUS_COMPLETE === status || REPORT_STATUS_REJECT === status || REPORT_STATUS_PASS === status
    },

    getRoundClassname (item) {
      const { status } = item

      if (!status) {
        return `border-color: ${getColorByType('primary')}`
      } else {
        const { borderColor } = REPORT_STATUS_FLOW_CONFIG[status]

        return `border-color: ${borderColor}`
      }
    },

  },

}
